import ServiceApi from "../services/service.api";
import ServiceStorage from "./../services/service.storage";

const baseServiceUrl = `/api/v1/SiteRoles`;


const ApiSiteRoles = {
  getInfos: () => {
    const url = `${baseServiceUrl}`;
    var response = ServiceApi.get(url);
    return response;
  },
};

export default ApiSiteRoles;